import styled from '@emotion/styled';

const IconButton = styled.button`
  background-color: transparent;
  color: #fff;
  font-size: 17px;
  padding: 5px;
  border: none;
`;
export default IconButton;
